













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class StatusIcon extends Vue {
  @Prop(String) type!: string;
  @Prop({ type: Number, default: 20 }) readonly size!: number;

  get dataStatus() {
    let obj = {};
    switch (this.type) {
      case 'error':
        obj = {
          iconName: 'mdi-close-circle',
          color: 'red',
        };
        break;
      case 'success':
        obj = {
          iconName: 'mdi-check-circle-outline',
          color: 'greenLight',
        };
        break;
      case 'waiting':
        obj = {
          iconName: 'mdi-alert-circle-outline',
          color: 'primary',
        };
        break;
      default:
        return {};
    }
    return obj;
  }
}
